import { Action } from '@ngrx/store';
import { ErrorResponse } from '../../../../shared/models/error-response.model';
import { Suggestion } from '../../models/suggestion.model';
import { HistoryTerm } from '../../models/history-term.model';
import { Product } from '~shared/models';

export enum SearchSuggestionsActionTypes {
  LOAD_SEARCH_SUGGESTIONS = '[Buyer] Search Suggestions read',
  LOAD_SEARCH_SUGGESTIONS_SUCCESS = '[Buyer] Search Suggestions read success',
  LOAD_SEARCH_SUGGESTIONS_FAILURE = '[Buyer] Search Suggestions read failure',

  ADD_SEARCH_HISTORY_TERM = '[Buyer] Search history term add',
  REMOVE_SEARCH_HISTORY_TERM = '[Buyer] Search history term remove',
  UPDATE_SEARCH_HISTORY_TERMS_SUCCESS = '[Buyer] Search history terms update success',

  SHOW_SUGGESTIONS_LIST = '[Buyer] Show suggestions list',
  HIDE_SUGGESTIONS_LIST = '[Buyer] Hide suggestions list',

  RESET_SUGGESTIONS = '[Buyer] Reset suggestions',
}

export class LoadSearchSuggestions implements Action {
  readonly type = SearchSuggestionsActionTypes.LOAD_SEARCH_SUGGESTIONS;

  constructor(public payload: { term: string }) {
  }
}

export class LoadSearchSuggestionsSuccess implements Action {
  readonly type = SearchSuggestionsActionTypes.LOAD_SEARCH_SUGGESTIONS_SUCCESS;

  constructor(public payload: { term: string, suggestions: Suggestion[], products: Product[] }) {
  }
}

export class LoadSearchSuggestionsFailure implements Action {
  readonly type = SearchSuggestionsActionTypes.LOAD_SEARCH_SUGGESTIONS_FAILURE;

  constructor(public payload: { error: ErrorResponse }) {
  }
}

export class AddSearchHistoryTerm implements Action {
  readonly type = SearchSuggestionsActionTypes.ADD_SEARCH_HISTORY_TERM;

  constructor(public payload: Suggestion) {
  }
}

export class RemoveSearchHistoryTerm implements Action {
  readonly type = SearchSuggestionsActionTypes.REMOVE_SEARCH_HISTORY_TERM;

  constructor(public payload: HistoryTerm) {
  }
}

export class UpdateSearchHistoryTermsSuccess implements Action {
  readonly type = SearchSuggestionsActionTypes.UPDATE_SEARCH_HISTORY_TERMS_SUCCESS;

  constructor(public payload: HistoryTerm[]) {
  }
}

export class ShowSuggestionsList implements Action {
  type = SearchSuggestionsActionTypes.SHOW_SUGGESTIONS_LIST;
}

export class HideSuggestionsList implements Action {
  type = SearchSuggestionsActionTypes.HIDE_SUGGESTIONS_LIST;
}

export class ResetSuggestions implements Action {
  readonly type = SearchSuggestionsActionTypes.RESET_SUGGESTIONS;
}

export type SearchSuggestionsActionsUnion =
  LoadSearchSuggestions
  | LoadSearchSuggestionsSuccess
  | LoadSearchSuggestionsFailure
  | AddSearchHistoryTerm
  | UpdateSearchHistoryTermsSuccess
  | RemoveSearchHistoryTerm
  | ShowSuggestionsList
  | HideSuggestionsList
  | ResetSuggestions;
